import { createListenerMiddleware } from '@reduxjs/toolkit';
import { baseApi } from '@/shared/api/baseApi';
import { sessionCleared, storeSelected } from '@/shared/lib/redux/actions';

/** Signing out, or switching the current store (§1 «магазины изолированы»), invalidates every RTK
 *  Query cache entry — otherwise a screen could briefly render stale/cross-tenant data. */
export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: sessionCleared,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});

listenerMiddleware.startListening({
  actionCreator: storeSelected,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});
